import { render, staticRenderFns } from "./shipperHiring.vue?vue&type=template&id=c0f7a1b6&scoped=true"
import script from "./shipperHiring.vue?vue&type=script&lang=js"
export * from "./shipperHiring.vue?vue&type=script&lang=js"
import style0 from "./shipperHiring.vue?vue&type=style&index=0&id=c0f7a1b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f7a1b6",
  null
  
)

export default component.exports